export class AdQueue {
  adUrl: string;
  bookingId: string;
  interval: number;
  length: number;
  userId: string;
  fileType?: string;

  constructor(
    adUrl?: string,
    bookingId?: string,
    interval?: number,
    length?: number,
    userId?: string,
    fileType?: string
  ) {
    this.adUrl = adUrl || null;
    this.bookingId = bookingId || null;
    this.interval = interval || null;
    this.length = length || null;
    this.userId = userId || null;
    this.fileType = fileType || null;
  }
}
